import { application } from "../application"
import ModalController from "./modal_controller"
import RegistrationController from "./registration_controller"

application.register("auth--modal", ModalController)
application.register("auth--registration", RegistrationController)
